(function($) {
/* override functions api.jquery.js */
Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.single-cart-item-loop');
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    var str = data.description;
  } else {
   	var str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  }
  $('.error_message').text(str);
  $('#modalAddToCartError').modal("toggle");
  setTimeout(function () {
  	$('.shopping__cart').removeClass("shopping__cart__on");
    $('.body__overlay').removeClass("is-visible");
  },2000);
}

Shopify.addItem = function(variant_id, quantity, callback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.addItemFromForm = function(form_id, variant_id,callback) {
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      beforeSend: function(){
        if(form_id == "add-item-qv") {
          $('#' + form_id).find(".addtocartqv").html($(".quickViewModal_info .button_wait").html());
        }
      },
      data: $('#' + form_id).serialize(),
      dataType: 'json',
      success: function(line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item);
        }
        else {
          if(form_id != "add-item-qv") {
            Shopify.cartPopapForm(variant_id);
          } else {
          	$('#' + form_id).find(".addtocartqv").html($(".quickViewModal_info .button_added").html());
            $('#' + form_id).find(".addtocartqv").addClass("added_in_cart");
            setTimeout(function(){
              	$('#' + form_id).find(".addtocartqv").removeClass("added_in_cart");
            	$('#' + form_id).find(".addtocartqv").html($(".quickViewModal_info .button").html());
            }, 2000);
          }
          Shopify.onItemAdded(line_item);
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        if(form_id != "add-item-qv") {
          Shopify.onError(XMLHttpRequest, textStatus);
        } else {
          $('#' + form_id).find(".addtocartqv").html($(".quickViewModal_info .button_error").html());
          $('#' + form_id).find(".addtocartqv").addClass("error_in_cart");
          setTimeout(function(){
            $('#' + form_id).find(".addtocartqv").removeClass("error_in_cart");
            $('#' + form_id).find(".addtocartqv").html($(".quickViewModal_info .button").html());
          }, 2000);
        }
        Shopify.onItemAdded(line_item);
      }
    };
    jQuery.ajax(params);
};

/* user functions */

Shopify.addItemFromFormStart = function(form, product_id) {
  Shopify.addItemFromForm(form, product_id);
}

Shopify.cartPopap = function(variant_id) {
  	var image = $('.'+variant_id+':first .popup_cart_image').attr("src");
  	var title = $('.'+variant_id+':first .popup_cart_title').text();
  	$('.popupimage').attr("src",''+image+'');
  	$('.productmsg').text('"'+title+'"');  
  	$('#modalAddToCart').modal("toggle");
}
Shopify.cartPopapForm = function(variant_id) {
  	var image = $('.product_variant_image').attr("src");
  	var title = $('#popup_cart_title').text();
  	$('.popupimage').attr("src",''+image+'');
	$('.productmsg').text('"'+title+'"');
	$('#modalAddToCart').modal("toggle");
}

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  var formatMoney = "<span class='money'>${{amount}}</span>";
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = $(cart_cell_id);
    if (cart_cell.length) {

      cart_cell.empty();

  
      jQuery.each(cart, function(key, value) {
        if (key === 'items') {
          
          if (value.length == 1) {
            $(".single-product-cart, .item-single-item-count").css({"display": "block"});
            $(".cart-empty-title, .item-multiple-item-count").css({"display": "none"});
            
            var table = $(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              $('<li class="single-shopping-cart"><div class="shopping-cart-img"><a href="' + item.url + '"><img alt="{{ cart_img.alt }}" src="' + item.image + '"></a></div><div class="shopping-cart-title"><h4><a href="' + item.url + '">' + item.title + '</a></h4><h6>Qty: ' + item.quantity + '</h6><span> ' + Shopify.formatMoney(item.price, formatMoney) + '</span></div><div class="shopping-cart-delete"><a href="javascript:void(0);" onclick="Shopify.removeItem(' + item.variant_id + ')"><i class="fa fa-times-circle"></i></a></div></li>').appendTo(table);
            });
          }			
          else if (value.length) {
            $(".single-product-cart, .item-multiple-item-count").css({"display": "block"});
            $(".cart-empty-title,  .item-single-item-count").css({"display": "none"});
            
            var table = $(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              $('<li class="single-shopping-cart"><div class="shopping-cart-img"><a href="' + item.url + '"><img alt="{{ cart_img.alt }}" src="' + item.image + '"></a></div><div class="shopping-cart-title"><h4><a href="' + item.url + '">' + item.title + '</a></h4><h6>Qty: ' + item.quantity + '</h6><span> ' + Shopify.formatMoney(item.price, formatMoney) + '</span></div><div class="shopping-cart-delete"><a href="javascript:void(0);" onclick="Shopify.removeItem(' + item.variant_id + ')"><i class="fa fa-times-circle"></i></a></div></li>').appendTo(table);
            });
          }
          else {
            $(".single-product-cart, .item-single-item-count").css({"display": "none"});
            $(".cart-empty-title").css({"display": "block"});
          }
        }
      });

      
    }
  }

  changeHtmlValue(".shopping-cart__total", Shopify.formatMoney(cart.total_price, formatMoney));
  changeHtmlValue(".bigcounter", cart.item_count);

  $('.currency .active').trigger('click');
}

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = $(cell);
  $cartLinkText.html(value);
};
})(Shopify.$ || jQuery);